import DateFnsUtils from "@date-io/date-fns"
import { createMuiTheme, MuiThemeProvider, Paper, TableCell, TextField, Typography, Tooltip, Snackbar, withStyles } from "@material-ui/core"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import MUIDataTable from "mui-datatables"
import { format } from 'date-fns';
import { createRef, useEffect, useReducer, useState } from "react"
import api from "../api"
import CloseImage from '../../assets/ic_close.png';
import IconArrow from '../../assets/ic_arrow.png';
import Loader from 'react-loader-spinner'
import { usePrevious } from '../../library/Util';
import CustomTextField from '../components/customTextField';
import MuiAlert from '@material-ui/lab/Alert';
import Constant from "../../library/Constant"
import icPanggil from '../../assets/ic_systemCall.png';
import icPanggilManual from '../../assets/ic_manualCall2.png';
import icCircleBlue from '../../assets/ic_circle_blue.png';
import icCircleGreen from '../../assets/ic_circle_light_green.png';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTablePemanggilan());

const options = ct.customOptionsSearch()

export default function TabSubFacility(props) {
    const [noAntri, setNoAntri] = useState("");
    const [dataTable, setDataTable] = useState([])
    const [listLokasi, setListLokasi] = useState([])
    const [waktu, setWaktu] = useState(new Date())
    const [newNotes, setNewNotes] = useState("")
    const [lokasi, setLokasi] = useState(null);
    const [addCatatan, setAddCatatan] = useState(false);
    const [disabledLoket, setDisabledLoket] = useState(false);
    const [idTab] = useState(props.idTab);
    const [namaPasien, setNamaPasien] = useState("")
    const [gender, setGender] = useState("")
    const [noRM, setNoRM] = useState("")
    const [referal, setReferal] = useState("")
    const [kodePesanan, setKodePesanan] = useState("")
    const [notes, setNotes] = useState("")
    const [open, setOpen] = useState(false);
    const [visibleStop, setVisibleStop] = useState(false)
    const [statusAntrian, setStatusAntrian] = useState("")
    const [queueNumber, setQueueNumber] = useState("")
    const [currentCounter, setCurrentCounter] = useState("")
    const [userID, setUserID] = useState("")
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);

    // const [facility_id, setFacilityID] = useState("")
    // const [facility_queue_id, setFacilityQueueID] = useState("")
    const [sub_facility_id, setSubFacilityID] = useState("")
    const [sub_facility_queue_id, setSubFacilityQueueID] = useState("")
    const [loading, setLoading] = useState(false)
    const [called, setCalled] = useState("")
    const prevCount = usePrevious(dataTable);
    const [dataLama, setDataLama] = useState([])
    const [dataBaru, setDataBaru] = useState([])
    const [disableStopButton, setDisableStopButton] = useState(true)

    const wrapperRef = createRef()

    const handleClick = () => {
        const wrapper = wrapperRef.current;
        // console.log(wrapper.classList);
        wrapper.classList.toggle('is-nav-open')
        setOpen(!open)
    }


    useEffect(() => {
        if (dataTable.length != (prevCount !== undefined ? prevCount.length : -1)) {
            getListCounter(0)
            getDataTable()
        }
        const interval = setInterval(() => {
            // console.log(props.idTab);
            // getDataTable()
            getData()
        }, 5000);
        return () => clearInterval(interval);
    }, [dataBaru])

    const getData = () => {
        if (props.skip === false) {
            api.create().getListSubFacility(props.idTab).then(response => {
                // console.log(response);
                if (response.data) {
                    if (response.data.data.length > 0) {
                        let a = response.data.data.filter(elm => !dataLama.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
                        // console.log(a);
                        if (a.length > 0) {
                            // console.log('1');
                            getDataTable()
                        } else if (response.data.data.length !== dataLama.length) {
                            // console.log('2');
                            getDataTable()
                        }
                    } else {
                        setDataBaru([])
                        setDataLama([])
                        setDataTable([])
                    }
                    props.refreshBadge()
                    setDataBaru(response.data.data)
                    // setLoading(false)
                }
            })
        } else {
            api.create().getPemanggilanSubFacilitySkip(props.idFacility).then(response => {
                // console.log(response);
                if (response.data) {
                    if (response.data) {
                        if (response.data.data.length > 0) {
                            let a = response.data.data.filter(elm => !dataLama.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
                            // console.log(a);
                            if (a.length > 0) {
                                // console.log('1');
                                getDataTable()
                            } else if (response.data.data.length !== dataLama.length) {
                                // console.log('2');
                                getDataTable()
                            }
                        } else {
                            setDataBaru([])
                            setDataLama([])
                            setDataTable([])
                        }
                        props.refreshBadge()
                        setDataBaru(response.data.data)
                    }
                }
            })
        }
    }

    const getListCounter = (id) => {
        api.create().getListCounter(props.idFacility).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let listCounter = []
                    response.data.data.counters.map((item, index) => {
                        if (item.status === 1) {
                            listCounter.push({
                                nama: item.name,
                                id: item.id
                            })
                        }
                    })
                    // console.log(listCounter);
                    if (listCounter.length > 0) {
                        listCounter = listCounter.sort((a, b) => a.nama.localeCompare(b.nama))
                    }
                    let idx = listCounter.findIndex((val) => String(val.id) === String(id))
                    if (idx > -1) {
                        setLokasi(listCounter[idx])
                    }
                    let current_counter = Number(localStorage.getItem(Constant.CURRENT_COUNTER))
                    console.log(current_counter, localStorage.getItem(Constant.SUB_FACILITY));
                    if (Number.isInteger(current_counter)) {
                        let idxCounter = listCounter.findIndex((val) => Number(val.id) === current_counter)
                        if (idxCounter > -1) {
                            if (localStorage.getItem(Constant.SUB_FACILITY) === String(props.idTab) || props.skip) {
                                setLokasi(listCounter[idxCounter])
                                setDisabledLoket(false)
                                forceUpdate()
                            } else {
                                setDisabledLoket(true)
                            }
                        } else {
                            setDisabledLoket(true)
                        }
                    } else {
                        setDisabledLoket(false)
                    }
                    setListLokasi(listCounter)
                }
            }
        })
    }

    useEffect(() => {
        getDataTable()
    }, [lokasi])

    const getDataTable = (counter) => {
        if (props.skip === false) {
            api.create().getListSubFacility(props.idTab).then(response => {
                console.log(response);
                if (response.data) {
                    let dataTable = []
                    if (response.data.data?.length > 0) {
                        dataTable = response.data.data.map((item, index) => {
                            return [
                                item.queue_number,
                                item.booking_id,
                                item.patient_medical_record_no === null ? item.patient_medical_record_no_2 : item.patient_medical_record_no,
                                item.patient_name === null ? item.patient_name_2 : item.patient_name,
                                item.patient_gender === null ? item.patient_gender_2 : item.patient_gender,
                                item.payment_option_name,
                                item.processed_by ? item.processed_by : '-',
                                item.facility_counter_name ? item.facility_counter_name : '-',
                                item.is_called === 1 && (item.queue_status_name === "New" || item.queue_status_name === "Menunggu") ? "Dipanggil" : item.is_called === 1 && (item.queue_status_name === "Process" || item.queue_status_name === "Dilayani") ? "Dilayani" : (item.queue_status_name === "Skip" || item.queue_status_name === "Dilewati") ? "Dilewati" : item.queue_status_name,
                                item.is_called,
                                item.facility_id,
                                item.facility_queue_id,
                                item.sub_facility_id,
                                item.sub_facility_queue_id,
                                item.facility_counter_id,
                                item.queue_status_id,
                            ]
                        })
                        if (lokasi) {
                            let idCounter = response.data.data.findIndex((val) => val.facility_counter_id === lokasi.id)
                            if (idCounter > -1) {
                                let id = response.data.data[idCounter].sub_facility_queue_id
                                getDetailPasien(id)
                            } else {
                                setLoading(false)
                            }
                        } else {
                            setLoading(false)
                        }
                        // if (counter === undefined) {
                        //     getListCounter(0)
                        // }
                        setDataLama(response.data.data)
                        setDataTable(dataTable)
                        setDisableStopButton(true)
                        //     forceUpdate()
                        // } else {
                        //     setDataTable([])
                        forceUpdate()
                        // }
                    }
                    setLoading(false)
                    forceUpdate()
                }
            })
        } else {
            api.create().getPemanggilanSubFacilitySkip(props.idFacility).then(response => {
                console.log(response);
                if (response.data) {
                    let dataTable = []
                    if (response.data.data?.length > 0) {
                        dataTable = response.data.data.map((item, index) => {
                            return [
                                item.queue_number,
                                item.booking_id,
                                item.patient_medical_record_no === null ? item.patient_medical_record_no_2 : item.patient_medical_record_no,
                                item.patient_name === null ? item.patient_name_2 : item.patient_name,
                                item.patient_gender === null ? item.patient_gender_2 : item.patient_gender,
                                item.payment_option_name,
                                item.processed_by ? item.processed_by : '-',
                                item.facility_counter_name ? item.facility_counter_name : '-',
                                item.is_called === 1 && (item.queue_status_name === "New" || item.queue_status_name === "Menunggu") ? "Dipanggil" : item.is_called === 1 && (item.queue_status_name === "Process" || item.queue_status_name === "Dilayani") ? "Dilayani" : (item.queue_status_name === "Skip" || item.queue_status_name === "Dilewati") ? "Dilewati" : item.queue_status_name,
                                item.is_called,
                                item.facility_id,
                                item.facility_queue_id,
                                item.sub_facility_id,
                                item.sub_facility_queue_id,
                                item.facility_counter_id,
                                item.queue_status_id,
                            ]
                        })
                        setDataTable(dataTable)
                        setDisableStopButton(true)
                        if (lokasi) {
                            let idCounter = response.data.data.findIndex((val) => val.facility_counter_id === lokasi.id)
                            console.log(response.data.data, counter);
                            if (idCounter > -1) {
                                let id = response.data.data[idCounter].sub_facility_queue_id
                                getDetailPasienSkip(id)
                            } else {
                                setLoading(false)
                            }
                        } else {
                            setLoading(false)
                        }
                        // } else {
                        // if (counter === undefined) {
                        //     getListCounter(0)   
                        // }
                        // }
                        forceUpdate()
                    } else {
                        setDataTable([])
                        // getListCounter(0)
                        forceUpdate()
                    }
                }
            })
        }
        setLoading(false)
    }

    const getDetailPasien = (id) => {
        api.create().getDetailListSubFacility(id).then(res => {
            console.log(res);
            if (res.data) {
                let data = res.data.data
                let a = new Date()
                let year = format(a, 'yyyy-MM-dd')
                let jam = (`${year}T${data.estimated_time}:00+07:00`)
                setWaktu(Date.parse(jam))
                setNoAntri(data.queue_number)
                setKodePesanan(data.booking_id)
                setCurrentCounter(data.facility_counter_id)
                setNamaPasien(data.patient_name)
                setGender(data.patient_gender)
                setNoRM(data.patient_medical_record_no === null ? "" : data.patient_medical_record_no)
                setNotes(data.notes)
                // setFacilityQueueID(data.facility_queue_id)
                setCalled(data.queue_status_name === "New" || data.queue_status_name === "Menunggu" || data.queue_status_name === "Dilewati" || data.queue_status_name === "Dipanggil" ? "panggil" : "proses")
                // setFacilityID(data.facility_id)
                setSubFacilityQueueID(id)
                setSubFacilityID(data.sub_facility_id)
                String(data.user_id) === String(localStorage.getItem(Constant.USER_ID)) && setDisabledLoket(true)
                setUserID(data.user_id)
                setQueueNumber(data.queue_number)
                setReferal(data.refferal_code === null ? "" : data.refferal_code)
                setStatusAntrian(data.queue_status_name === "Menunggu" ? "Next" : data.queue_status_name === "Dilewati" ? "Next" : data.queue_status_name === "Darurat" || data.queue_status_name === "Dipanggil" ? "Next" : "Proses")
                setLoading(false)
                // getListCounter(data.facility_counter_id)
            } else {
                setLoading(false)
            }
        })
    }

    const getDetailPasienSkip = (id) => {
        api.create().getDetailListSubFacility(id).then(res => {
            if (res.data) {
                console.log(res);
                let data = res.data.data
                let a = new Date()
                let year = format(a, 'yyyy-MM-dd')
                let jam = (`${year}T${data.estimated_time}:00+07:00`)
                setWaktu(Date.parse(jam))
                setNoAntri(data.queue_number)
                setCurrentCounter(data.facility_counter_id)
                setKodePesanan(data.booking_id)
                setNamaPasien(data.patient_name)
                setGender(data.patient_gender)
                setNoRM(data.patient_medical_record_no === null ? "" : data.patient_medical_record_no)
                setNotes(data.notes)
                // setFacilityQueueID(data.facility_queue_id)
                setCalled(data.queue_status_name === "New" || data.queue_status_name === "Skip" || data.queue_status_name === "Menunggu" || data.queue_status_name === "Dilewati" || data.queue_status_name === "Dipanggil" ? "panggil" : "proses")
                // setFacilityID(data.facility_id)
                setSubFacilityQueueID(id)
                setQueueNumber(data.queue_number)
                setUserID(data.user_id)
                setSubFacilityID(data.sub_facility_id)
                String(data.user_id) === String(localStorage.getItem(Constant.USER_ID)) && setDisabledLoket(true)
                setReferal(data.refferal_code === null ? "" : data.refferal_code)
                setStatusAntrian(data.queue_status_name === "New" || data.queue_status_name === "Skip" || data.queue_status_name === "Menunggu" || data.queue_status_name === "Dilewati" || data.queue_status_name === "Dipanggil" ? "Next" : "Proses")
                setLoading(false)
                // if (counter !== undefined) {
                // getListCounter(data.facility_counter_id)
                // }
                // getListCounter(data.facility_counter_id)
                forceUpdate()
            } else {
                setLoading(false)
            }
        })
    }

    const handleCall = ({ rowData }) => {
        setLoading(true)
        if (props.loket === true) {
            if (lokasi === null) {
                alert('Loket Tidak Boleh Kosong')
                setLoading(false)
            } else {
                let payload = {
                    "facility_id": rowData[10],
                    "facility_counter_id": lokasi.id,
                    "sub_facility_id": rowData[12],
                    "sub_facility_queue_id": rowData[13],
                    "status": "CALL"
                }
                console.log(payload);
                api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setStatusAntrian("Next")
                            localStorage.setItem(Constant.CURRENT_COUNTER, lokasi.id)
                            localStorage.setItem(Constant.SUB_FACILITY, rowData[12])
                            getDataTable(lokasi)
                        } else {
                            if (response.data.data) {
                                alert(response.data.data)
                            }
                            setLoading(false)
                        }
                    }
                })
            }
        } else {
            let payload = {
                "facility_id": rowData[10],
                "sub_facility_id": rowData[12],
                "sub_facility_queue_id": rowData[13],
                "status": "CALL"
            }
            api.create().updateListPemanggilanSubFacility(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setStatusAntrian("Next")
                        getDataTable(lokasi)
                        localStorage.setItem(Constant.CURRENT_COUNTER, lokasi.id)
                        localStorage.setItem(Constant.SUB_FACILITY, rowData[12])
                        // let data = response.data.data
                        // let a = new Date()
                        // let year = format(a, 'yyyy-MM-dd')
                        // let jam = (`${year}T${data.estimated_time}:00+07:00`)
                        // setWaktu(Date.parse(jam))
                        // setNoAntri(data.queue_number)
                        // setKodePesanan(data.booking_id)
                        // setNamaPasien(data.patient_name)
                        // setNotes(data.notes)
                        // setFacilityQueueID(data.facility_queue_id)
                        // setFacilityID(data.facility_id)
                        // setSubFacilityQueueID(data.sub_facility_queue_id)
                        // setSubFacilityID(data.sub_facility_id)
                        // setStatusAntrian("Dipanggil")
                        // forceUpdate()
                    } else {
                        setLoading(false)
                    }
                }
            })
        }
    }

    const handleManualCall = ({ rowData }) => {
        console.log(rowData);
        setLoading(true)
        if (props.loket === true) {
            if (lokasi === null) {
                alert('Loket Tidak Boleh Kosong')
                setLoading(false)
            } else {
                let payload = {
                    "facility_id": rowData[10],
                    "facility_counter_id": lokasi.id,
                    "sub_facility_id": rowData[12],
                    "sub_facility_queue_id": rowData[13],
                    "without_call": 1,
                    "status": "CALL"
                }
                console.log(payload, rowData);
                api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setStatusAntrian("Next")
                            getDataTable(lokasi)
                            localStorage.setItem(Constant.CURRENT_COUNTER, lokasi.id)
                            localStorage.setItem(Constant.SUB_FACILITY, rowData[12])
                        } else {
                            if (response.data.data) {
                                alert(response.data.data)
                            }
                            setLoading(false)
                        }
                    }
                })
            }
        } else {
            let payload = {
                "facility_id": rowData[10],
                "sub_facility_id": rowData[12],
                "sub_facility_queue_id": rowData[13],
                "without_call": 1,
                "status": "CALL"
            }
            api.create().updateListPemanggilanSubFacility(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setStatusAntrian("Next")
                        getDataTable(lokasi)
                        localStorage.setItem(Constant.CURRENT_COUNTER, lokasi.id)
                        localStorage.setItem(Constant.SUB_FACILITY, rowData[12])
                    } else {
                        setLoading(false)
                    }
                }
            })
        }
    }

    const handleSkip = () => {
        setLoading(true)
        if (props.loket === true) {
            if (lokasi === null) {
                alert('Loket Tidak Boleh Kosong')
                setLoading(false)
            } else {
                let payload = {
                    "facility_id": props.idFacility,
                    "sub_facility_id": sub_facility_id,
                    "facility_counter_id": lokasi.id,
                    "sub_facility_queue_id": sub_facility_queue_id,
                    "status": "SKIP"
                }
                console.log(payload);
                api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            getDataTable(lokasi)
                            setStatusAntrian("")
                            setDisabledLoket(false)
                            setNoAntri("")
                            setKodePesanan("")
                            setNamaPasien("")
                            setNoRM("")
                            setNotes("")
                            setReferal("")
                            setCalled("")
                            localStorage.setItem(Constant.CURRENT_COUNTER, "CURRENT_COUNTER")
                            localStorage.setItem(Constant.SUB_FACILITY, "SUB_FACILITY")
                            forceUpdate()
                        }
                    } else {
                        if (response.data.data) {
                            alert(response.data.data)
                        }
                        setLoading(false)
                    }
                })
            }
        } else {
            let payload = {
                "facility_id": props.idFacility,
                "sub_facility_id": props.idTab,
                "sub_facility_queue_id": sub_facility_queue_id,
                "status": "SKIP"
            }
            api.create().updateListPemanggilanSubFacility(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        getDataTable(lokasi)
                        setStatusAntrian("")
                        setNoAntri("")
                        setDisabledLoket(false)
                        setKodePesanan("")
                        setNamaPasien("")
                        setNoRM("")
                        setReferal("")
                        setNotes("")
                        setCalled("")
                        localStorage.setItem(Constant.CURRENT_COUNTER, "CURRENT_COUNTER")
                        localStorage.setItem(Constant.SUB_FACILITY, "SUB_FACILITY")
                        forceUpdate()
                    } else {
                        setLoading(false)
                    }
                }
            })
        }
    }

    const handleNextPatient = () => {
        setLoading(true)
        if (props.loket === true) {
            if (lokasi === null) {
                alert('Loket Tidak Boleh Kosong')
                setLoading(false)
            } else {
                let payload = {
                    "facility_id": props.idFacility,
                    "sub_facility_id": props.idTab,
                    "facility_counter_id": lokasi.id,
                    "sub_facility_queue_id": null,
                    "status": "NEXT"
                }
                // console.log(payload);
                api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            if (response.data.data === true) {
                                getDataTable(lokasi)
                                alert('Antrian tidak tersedia')
                            } else {
                                setStatusAntrian("Next")
                                getDataTable(lokasi)
                                localStorage.setItem(Constant.CURRENT_COUNTER, lokasi.id)
                                localStorage.setItem(Constant.SUB_FACILITY, props.idTab)
                            }
                        } else {
                            if (response.data.data) {
                                alert(response.data.data)
                            }
                            setLoading(false)
                        }
                    }
                })
            }
        } else {
            let payload = {
                "facility_id": props.idFacility,
                "sub_facility_id": props.idTab,
                "sub_facility_queue_id": null,
                "status": "NEXT"
            }
            api.create().updateListPemanggilanSubFacility(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data === true) {
                            getDataTable(lokasi)
                            alert('Antrian tidak tersedia')
                        } else {
                            setStatusAntrian("Next")
                            getDataTable(lokasi)
                            localStorage.setItem(Constant.CURRENT_COUNTER, lokasi.id)
                            localStorage.setItem(Constant.SUB_FACILITY, props.idTab)
                        }
                        // let data = response.data.data
                        // let a = new Date()
                        // let year = format(a, 'yyyy-MM-dd')
                        // let jam = (`${year}T${data.estimated_time}:00+07:00`)
                        // setWaktu(Date.parse(jam))
                        // setNoAntri(data.queue_number)
                        // setKodePesanan(data.booking_id)
                        // setNamaPasien(data.patient_name)
                        // setNoRM(data.patient_medical_record_no === null ? "" : data.patient_medical_record_no)
                        // setNotes(data.notes)
                        // setFacilityQueueID(data.facility_queue_id)
                        // setCalled("panggil")
                        // setDisabledLoket(true)
                        // setFacilityID(data.facility_id)
                        // setSubFacilityQueueID(data.sub_facility_queue_id)
                        // setSubFacilityID(data.sub_facility_id)
                        // setStatusAntrian("Dipanggil")
                        // forceUpdate()
                    } else {
                        setLoading(false)
                    }
                }
            })
        }
    }

    const handleStart = () => {
        setLoading(true)
        if (props.loket === true) {
            if (lokasi === null) {
                alert('Loket Tidak Boleh Kosong')
                setLoading(false)
            } else {
                let payload = {
                    "facility_id": props.idFacility,
                    "sub_facility_id": sub_facility_id,
                    "facility_counter_id": lokasi.id,
                    "sub_facility_queue_id": sub_facility_queue_id,
                    "new_notes": newNotes,
                    "refferal_code": referal,
                    "status": "START"
                }
                console.log(payload);
                api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            getDataTable(lokasi)
                            setStatusAntrian("Proses")
                        } else {
                            setLoading(false)
                        }
                    }
                })
            }
        } else {
            let payload = {
                "facility_id": props.idFacility,
                "sub_facility_id": sub_facility_id,
                "sub_facility_queue_id": sub_facility_queue_id,
                "new_notes": newNotes,
                "refferal_code": referal,
                "status": "START"
            }
            console.log(payload);
            api.create().updateListPemanggilanSubFacility(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        getDataTable(lokasi)
                        setStatusAntrian("Proses")
                    } else {
                        setLoading(false)
                    }
                }
            })
        }

    }

    const handleStop = () => {
        setLoading(true)
        setDisableStopButton(false)
        if (props.loket === true) {
            if (lokasi === null) {
                alert('Loket Tidak Boleh Kosong')
                setLoading(false)
                setDisableStopButton(true)
            } else {
                let payload = {
                    "facility_id": props.idFacility,
                    "sub_facility_id": sub_facility_id,
                    "facility_counter_id": lokasi.id,
                    "sub_facility_queue_id": sub_facility_queue_id,
                    "new_notes": newNotes,
                    "refferal_code": referal,
                    "status": "DONE"
                }
                console.log(payload);
                api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setNoAntri("")
                            setStatusAntrian("")
                            setKodePesanan("")
                            setDisabledLoket(false)
                            setNamaPasien("")
                            setNoRM("")
                            setNotes("")
                            setNewNotes("")
                            setUserID("")
                            setCurrentCounter("")
                            setVisibleStop(false)
                            setCalled("")
                            setAddCatatan("")
                            setReferal("")
                            getDataTable(lokasi)
                            localStorage.setItem(Constant.CURRENT_COUNTER, "CURRENT_COUNTER")
                            localStorage.setItem(Constant.SUB_FACILITY, "SUB_FACILITY")
                        } else {
                            if (response.data.data) {
                                alert(response.data.data)
                                // setOpenAlert(true)
                                // setMessageAlert(response.data.data)
                                // setStatusAlert("warning")
                            }
                            setLoading(false)
                            setDisableStopButton(true)
                        }
                    }
                })
            }
        } else {
            let payload = {
                "facility_id": props.idFacility,
                "sub_facility_id": sub_facility_id,
                "sub_facility_queue_id": sub_facility_queue_id,
                "new_notes": newNotes,
                "refferal_code": referal,
                "status": "DONE"
            }
            console.log(payload);
            api.create().updateListPemanggilanSubFacility(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setNoAntri("")
                        setStatusAntrian("")
                        setKodePesanan("")
                        setDisabledLoket(false)
                        setNamaPasien("")
                        setNoRM("")
                        setNotes("")
                        setCalled("")
                        setVisibleStop(false)
                        setAddCatatan("")
                        setReferal("")
                        getDataTable(lokasi)
                        localStorage.setItem(Constant.CURRENT_COUNTER, "CURRENT_COUNTER")
                        localStorage.setItem(Constant.SUB_FACILITY, "SUB_FACILITY")
                    } else {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("warning")
                        }
                        setLoading(false)
                        setDisableStopButton(true)
                    }
                }
            })
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const forceUpdate = useReducer(bool => !bool)[1];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 2110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const columns = [
        {
            name: "No. Antrian",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "ID Reservasi",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "No. Rekam Medis",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Nama Pasien",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ textAlign: 'center', fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Jenis Kelamin",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Opsi Pembayaran",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Process By",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Counter Name",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Status",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        !props.skip ? {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                sort: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {/* <button
                                style={{ padding: '0 10px', height: 'min-content', outline: 'none', borderColor: 'transparent', backgroundColor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? '#0094ff' : 'gray', borderRadius: 20, width: 'max-content', cursor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? 'pointer' : 'default' }}
                                onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? handleCall(tableMeta) : null}
                            >
                                <Typography style={{ color: 'white' }}>Panggil</Typography>
                            </button> */}
                            {((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) && disableStopButton === true ?
                                <LightTooltip title={"Panggil"} arrow>
                                    <div
                                        onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) ? handleCall(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleGreen})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 10, cursor: 'pointer' }}>
                                        <img src={icPanggil} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                            {((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) && disableStopButton === true ?
                                <LightTooltip title={"Panggil Manual"} arrow>
                                    <div
                                        onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) ? handleManualCall(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleBlue})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                        <img src={icPanggilManual} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                            {/* <button
                                style={{ padding: '0 10px', height: 'min-content', outline: 'none', borderColor: 'transparent', backgroundColor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? '#0094ff' : 'gray', borderRadius: 20, width: 'max-content', cursor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? 'pointer' : 'default' }}
                                onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? handleManualCall(tableMeta) : null}
                            >
                                <Typography style={{ color: 'white' }}>Panggil Manual</Typography>
                            </button> */}
                        </div>
                    )
                }
            }
        } : {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {/* <button
                                style={{ padding: '0 10px', height: 'min-content', outline: 'none', borderColor: 'transparent', backgroundColor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? '#0094ff' : 'gray', borderRadius: 20, width: 'max-content', cursor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? 'pointer' : 'default' }}
                                onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? handleCall(tableMeta) : null}
                            >
                                <Typography style={{ color: 'white' }}>Panggil</Typography>
                            </button>
                            <button
                                style={{ padding: '0 10px', height: 'min-content', outline: 'none', borderColor: 'transparent', backgroundColor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? '#0094ff' : 'gray', borderRadius: 20, width: 'max-content', cursor: ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? 'pointer' : 'default' }}
                                onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[7] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[7] === 0)) ? handleManualCall(tableMeta) : null}
                            >
                                <Typography style={{ color: 'white' }}>Panggil Manual</Typography>
                            </button> */}
                            {((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) && disableStopButton === true ?
                                <LightTooltip title={"Panggil"} arrow>
                                    <div
                                        onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) ? handleCall(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleGreen})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 10, cursor: 'pointer' }}>
                                        <img src={icPanggil} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                            {((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) && disableStopButton === true ?
                                <LightTooltip title={"Panggil Manual"} arrow>
                                    <div
                                        onClick={() => ((statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) && (tableMeta.rowData[9] === 1 && queueNumber === tableMeta.rowData[0])) || (statusAntrian === "" && tableMeta.rowData[9] === 0)) ? handleManualCall(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleBlue})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                        <img src={icPanggilManual} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',

    };

    return (
        <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
            {loading ? loadingComponent : null}
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {props.loket && (
                <div style={{ display: 'flex', width: '100%' }}>
                    <Autocomplete
                        options={listLokasi}
                        getOptionLabel={(option) => option.nama}
                        id="lokasi"
                        onChange={(event, newInputValue) => {
                            setLokasi(newInputValue)
                            setStatusAntrian("")
                            // getDataTable(newInputValue)
                            forceUpdate()
                        }}
                        disabled={disabledLoket}
                        underlineShow={false}
                        disableClearable
                        placeholder={"Pilih Lokasi"}
                        style={{ width: 150, marginBottom: 20, backgroundColor: 'white', borderRadius: 10, boxShadow: '5px 5px 10px 0 #999999' }}
                        renderInput={(params) =>
                            <TextField
                                placeholder={"Pilih Loket"}
                                {...params}
                                InputProps={{ ...params.InputProps, disableUnderline: true }}
                                margin="normal" style={{ paddingLeft: 20, paddingRight: 10, margin: 0 }}
                            />}
                        value={lokasi}
                    />
                    {/* <button
                        style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#0094ff', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 40 }}
                        onClick={() => getDataTable()}
                    >
                        <Typography style={{ color: 'white' }}>Refresh Data</Typography>
                    </button> */}
                    {!loading && (
                        <div style={{ display: 'flex', width: '80%' }}>
                            {statusAntrian === "" && !props.skip ?
                                <button
                                    style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#0094FF', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                    onClick={() => handleNextPatient()}
                                >
                                    <Typography style={{ color: 'white' }}>Antrian Selanjutnya</Typography>
                                </button>
                                : statusAntrian === "Next" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) ?
                                    <div style={{ display: 'flex' }}>
                                        <button
                                            style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#4CDC63', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                            onClick={() => handleStart()}
                                        >
                                            <Typography style={{ color: 'white' }}>Start</Typography>
                                        </button>
                                        <button
                                            style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#EDD60A', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                            onClick={() => handleSkip()}
                                        >
                                            <Typography style={{ color: 'white' }}>Lewati</Typography>
                                        </button>
                                    </div>
                                    : statusAntrian === "Proses" && String(userID) === String(localStorage.getItem(Constant.USER_ID)) ?
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <button
                                                style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#FF5B5B', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                                onClick={() => setVisibleStop(true)}
                                            >
                                                <Typography style={{ color: 'white' }}>Stop</Typography>
                                            </button>
                                            <div style={{ width: '30%' }}>
                                                <CustomTextField
                                                    value={referal}
                                                    placeholder={"No. Referensi"}
                                                    onChange={(val) => {
                                                        setReferal(val)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        : null
                            }
                        </div>
                    )}
                </div>
            )}

            {!loading && (
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dataTable}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            )}
            {visibleStop && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleStop(false)
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <div style={{ height: '30vh' }}>
                            <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 30 }}>Catatan Baru</Typography>
                            <textarea
                                label="Catatan Petugas"
                                value={newNotes}
                                onChange={(e) => {
                                    setNewNotes(e.target.value)
                                }}
                                style={{ width: '70%', marginTop: 10, height: '15vh' }}
                                placeholder={"input catatan baru"}
                            />
                            <Typography style={{ fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa diubah</Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%' }}>
                                <div
                                    onClick={() => handleStop()}
                                    style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Paper>
    )
}
